// extracted by mini-css-extract-plugin
module.exports = {"view":"_5970","image":"_465","full":"_9573","video":"_9821","button":"_11506","arrow":"_1612"};